
import { defineComponent } from 'vue';
import MainFooter from "@/layouts/main-footer/MainFooter.vue";

export default defineComponent({
  name: `LayoutAuthorization`,
  components: { MainFooter }
});
